import React from 'react';
import HeaderOneLine from 'common/components/HeaderOneLine/HeaderOneLine';
import i18n from 'common/locale/i18n';
import Loadable from 'common/libs/Loadable/Loadable';
import DefaultLoadingScreen from 'common/components/DefaultLoadingScreen/DefaultLoadingScreen';

const BusPaxManifestSearch = Loadable({
  loader: () =>
    import(/* webpackChunkName: "BusPaxManifestSearch" */ 'modules/bus/pax-manifest/search/components/BusPaxManifestSearch/BusPaxManifestSearch'),
  loading: DefaultLoadingScreen,
});

const BusPaxManifestScreen = props => <BusPaxManifestSearch {...props} />;
BusPaxManifestScreen.navigationOptions = {
  headerTitle: <HeaderOneLine title={i18n.getText('choose_bus')} />,
};
export default BusPaxManifestScreen;
